import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'

const emitQueryErrorEvent = (source: 'query' | 'mutation', error: unknown): void => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(
    new CustomEvent('app:query-error', {
      detail: {
        source,
        error,
      },
    })
  )
}

export const STALE_TIME = {
  STATIC: 30 * 60_000,
  SEMI_STATIC: 60_000,
  DYNAMIC: 30_000,
} as const

export const createAppQueryClient = (): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 0,
        gcTime: 0,
        retry: 1,
        refetchOnWindowFocus: false, // disable to prevent unnecessary refetches
        refetchOnReconnect: true,
      },
      mutations: {
        retry: false,
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        // only show global snackbar
        if (query.state.data !== undefined) {
          emitQueryErrorEvent('query', error)
        }
      },
    }),
    mutationCache: new MutationCache({
      onError: (_error, _variables, _context, mutation) => {
        // only show global snackbar
        if (!mutation.options.onError) {
          emitQueryErrorEvent('mutation', _error)
        }
      },
    }),
  })
}
